(() => {
  const selectors = document.querySelectorAll('[data-rehair-base-selector]');

  selectors.forEach((selector) => {
    const form = selector.querySelector('[data-selector-form]');
    const result = selector.querySelector('[data-selector-result]');
    const productData = selector.querySelector('[data-selector-products]');
    const progressBar = selector.querySelector('[data-selector-progress-bar]');
    const progressText = selector.querySelector('[data-selector-progress-text]');

    if (!form || !result || !productData) return;

    let products;
    try {
      products = JSON.parse(productData.textContent);
    } catch (error) {
      return;
    }

    const productMap = new Map(products.map((product) => [product.key, product]));
    const answerNames = ['wear', 'priority', 'lifestyle'];
    let hasStarted = false;

    const track = (event, payload = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...payload });
    };

    const updateProgress = () => {
      const answered = answerNames.filter((name) => form.querySelector(`input[name="${name}"]:checked`)).length;
      const percentage = Math.round((answered / answerNames.length) * 100);
      progressBar.style.width = `${percentage}%`;
      progressText.textContent = `${answered} of ${answerNames.length} answered`;
    };

    const addScores = (scores, values) => {
      Object.entries(values).forEach(([key, amount]) => {
        scores[key] = (scores[key] || 0) + amount;
      });
    };

    const rankProducts = (answers) => {
      const scores = {
        skin: 0,
        lace: 0,
        hybrid: 0,
        'mono-lace': 0,
        mono: 0
      };

      const wearScores = {
        extended: { lace: 3, hybrid: 2, skin: 1, 'mono-lace': 1 },
        daily: { mono: 3, 'mono-lace': 2, hybrid: 2 },
        unsure: { hybrid: 3, lace: 1, 'mono-lace': 1 }
      };
      const priorityScores = {
        natural: { skin: 3, lace: 2, hybrid: 1 },
        breathable: { lace: 3, hybrid: 2, 'mono-lace': 1 },
        cleanup: { skin: 3, hybrid: 2, mono: 1 },
        durable: { mono: 3, 'mono-lace': 2, hybrid: 1 }
      };
      const lifestyleScores = {
        active: { lace: 3, hybrid: 2, 'mono-lace': 1 },
        balanced: { hybrid: 3, lace: 1, skin: 1 },
        easycare: { skin: 3, hybrid: 2, mono: 1 }
      };

      addScores(scores, wearScores[answers.wear] || {});
      addScores(scores, priorityScores[answers.priority] || {});
      addScores(scores, lifestyleScores[answers.lifestyle] || {});

      return Object.entries(scores)
        .filter(([key]) => productMap.has(key))
        .sort((a, b) => b[1] - a[1]);
    };

    const showResult = (ranked, answers) => {
      const primary = productMap.get(ranked[0][0]);
      const secondary = productMap.get(ranked[1][0]);

      if (!primary) return;

      const image = result.querySelector('[data-result-image]');
      const title = result.querySelector('[data-result-title]');
      const description = result.querySelector('[data-result-description]');
      const bestFor = result.querySelector('[data-result-best-for]');
      const strength = result.querySelector('[data-result-strength]');
      const tradeoff = result.querySelector('[data-result-tradeoff]');
      const primaryLink = result.querySelector('[data-result-primary-link]');
      const secondaryLink = result.querySelector('[data-result-secondary-link]');

      image.src = primary.image;
      image.alt = primary.imageAlt;
      title.textContent = primary.name;
      description.textContent = primary.summary;
      bestFor.textContent = `Best for: ${primary.bestFor}`;
      strength.textContent = `Why it fits: ${primary.strength}`;
      tradeoff.textContent = `Know before buying: ${primary.tradeoff}`;
      primaryLink.href = primary.url;
      primaryLink.dataset.result = primary.key;

      if (secondary) {
        secondaryLink.hidden = false;
        secondaryLink.href = secondary.url;
        secondaryLink.textContent = `Compare with ${secondary.name}`;
        secondaryLink.dataset.result = secondary.key;
      } else {
        secondaryLink.hidden = true;
      }

      result.hidden = false;
      result.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });

      track('rehair_base_selector_complete', {
        base_result: primary.key,
        base_alternative: secondary ? secondary.key : '',
        wear_routine: answers.wear,
        base_priority: answers.priority,
        base_lifestyle: answers.lifestyle
      });
    };

    form.addEventListener('change', () => {
      if (!hasStarted) {
        hasStarted = true;
        track('rehair_base_selector_start');
      }
      updateProgress();
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      const formData = new FormData(form);
      const answers = Object.fromEntries(answerNames.map((name) => [name, formData.get(name)]));
      showResult(rankProducts(answers), answers);
    });

    selector.querySelectorAll('[data-selector-product-link]').forEach((link) => {
      link.addEventListener('click', () => {
        track('rehair_base_selector_product_click', {
          base_result: link.dataset.result || 'comparison'
        });
      });
    });

    updateProgress();
  });
})();
